export const BRAND_COLORS = {
    primary: '#4f46e5',
    primaryHover: '#4338ca',
    accent: '#06b6d4',
    backgroundDark: '#0f172a',
    surfaceDark: '#1e293b',
};
export const PLATFORM_DEFAULTS = {
    title: 'Safe AI Ministry Platform',
    attribution: 'Owned by DoxaTech LLC and Hoghores Limited.',
};
//# sourceMappingURL=index.js.map